<script lang="ts">
    import { Swiper, SwiperSlide } from "swiper/svelte"
    import SwiperCore, {
        Navigation,
        Pagination,
        EffectFade,
        Autoplay,
    } from "swiper"

    // Templates
    import Slide from "./Slide.svelte"
    import Slide2 from "./Slide2.svelte"

    SwiperCore.use([EffectFade, Navigation, Pagination, Autoplay])

    export let dots: boolean = false
    export let arrows: boolean = false
    export let effect
    export let type
    export let template
    export let slides: any[]
</script>

{#if slides?.length}
    <div id="slider" class="{type}">
        <Swiper
            effect="{effect}"
            navigation="{arrows}"
            autoplay="{false}"
            pagination="{dots ? { clickable: true } : false}"
        >
            {#each slides as item}
                <SwiperSlide>
                    {#if template == "style2"}
                        <Slide2 item="{item}" />
                    {:else}
                        <Slide item="{item}" />
                    {/if}
                </SwiperSlide>
            {/each}
        </Swiper>
    </div>
{/if}

<style lang="less" global>
    @import "../../css/base.less";
    @import "swiper/swiper.less";
    @import "swiper/modules/effect-fade/effect-fade.less";
    @import "swiper/modules/navigation/navigation.less";
    @import "swiper/modules/pagination/pagination.less";

    #slider {
        width: 100%;
        max-width: 100%;
        .swiper-slide {
            .opacity(0) !important;
            // visibility: hidden;
            &.swiper-slide-active {
                .opacity(1) !important;
                // visibility: visible;
            }
        }
    }

    .postslider1 {
        height: auto;
        .swiper-wrapper {
            align-items: flex-end;
            margin-bottom: 30px;
        }
    }

    .swiper {
        height: 100%;
        width: 100%;
        overflow: visible;
    }
    .swiper-pagination {
        bottom: -7px !important;
        height: 7px;
        background: #fff;
        .flex();
    }
    .swiper-pagination-bullet {
        // width: 12px;
        // height: 12px;
        // background: #fff;
        height: 100%;
        flex: 1;
        border-radius: 0;
        margin: 0px !important;
        background: #fff;
    }
    .swiper-pagination-bullet-active {
        background: @maincolor;
    }
    .swiper-button-prev,
    .swiper-button-next {
        color: #878787;
        top: inherit;
        bottom: -60px;
        &:after {
            font-size: 25px;
            @media (min-width: 768px) {
                font-size: 25px;
            }
        }
    }
    .swiper-button-next {
        right: 0px;
    }
    .swiper-button-prev {
        left: inherit;
        right: 30px;
    }

    // Hero Slider
    .heroslider {
        margin-bottom: 50px;
        height: 500px;
        background: #ffffff;
        .flex();
        align-items: center;
        justify-content: center;
        // @media (max-width: 1600px) {
        //     height: 30vw;
        // }
        @media (max-width: 768px) {
            height: 370px;
        }
        -webkit-box-shadow: 0px 20px 30px 3px rgba(0, 0, 0, 0.2);
        box-shadow: 0px 20px 30px 3px rgba(0, 0, 0, 0.2);
        @media (max-width: 500px) {
            height: auto;
            margin-bottom: 0px;
            .swiper-button-prev,
            .swiper-button-next {
                bottom: 0;
            }
        }
    }

    // Post Slider 1
    .postslider1 .swiper-button-prev,
    .postslider1 .swiper-button-next {
        bottom: 20px;
        color: #fff;
    }
</style>
